<template>
  <div>
    <h1 class="page-title">{{ $t('EditOfferContract.title') }}</h1>
    <div class="card card-transparent">
      <div class="card-block">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <form @submit.prevent="onSubmit" class="form-horizontal" role="form" novalidate="novalidate">

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("models.offer.replacement_motive") }}
                  <p class="offer-form-notice">
                    {{ $t("models.offer.not_visible_by_candidate") }}
                  </p>
                </label>
                <div class="col-md-8">
                  <multiselect v-model="replacementMotive"
                               track-by="id"
                               label="name"
                               :options="replacementMotivesOptions"
                               :placeholder="$t('multiselect.placeholder')"
                               :showLabels="true"
                               :allow-empty="true"
                               deselectLabel="X"
                               selectedLabel="X"
                               selectLabel="">
                    <span slot="noResult">{{ $t("multiselect.no_result") }}</span>
                  </multiselect>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t("models.offer.replacement_motive_detail") }}
                  <p class="offer-form-notice">
                    {{ $t("models.offer.not_visible_by_candidate") }}
                  </p>
                </label>
                <div class="col-md-8">
                <textarea name="replacement_motive_details"
                          v-model="replacementMotiveDetails"
                          id="replacement_motive_details"
                          class="form-control"
                          rows="3"></textarea>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-4">
                  <label class="control-label">
                    {{ $t("models.offer.replaced_person") }}
                    <p class="offer-form-notice">
                      {{ $t("models.offer.not_visible_by_candidate") }}
                    </p>
                  </label>
                </div>
                <div class="col-md-8">
                  <input v-model="replacedPerson" class="form-control" type="text">
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t('models.offer.replaced_person_salary_category') }}
                  <p class="offer-form-notice">
                    {{ $t("models.offer.not_visible_by_candidate") }}
                  </p>
                </label>
                <div class="col-md-8">
                  <input v-model="replacedPersonSalaryCategory" class="form-control" type="text">
                </div>
              </div>

              <div class="form-group row">
                <label class="col-md-4 control-label">
                  {{ $t('models.offer.replaced_person_salary') }}
                  <p class="offer-form-notice">
                    {{ $t("models.offer.not_visible_by_candidate") }}
                  </p>
                </label>
                <div class="col-md-8">
                  <input v-model="salary" class="form-control" type="text">
                </div>
              </div>
              <div class="pull-right row mt-4">
                <router-link :to="adminOfferPage" class="btn btn-default btn-cons" :disabled="loading">
                  {{ $t("buttons.cancel") }}
                </router-link>
                <button type="submit" class="btn btn-primary btn-cons" :disabled="loading">
                  {{ $t("buttons.save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { canEditOfferContractFields } from '@/helpers/contracts'
import { updateContractFields } from '@/backend/contracts'

export default {
  name: 'EditOffer',
  data(){
    return {
      replacementMotive: null,
      replacementMotiveDetails: null,
      replacedPerson: null,
      replacedPersonSalaryCategory: null,
      salary: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      replacementMotivesOptions: 'replacementMotives/replacementMotives',
      currentUser: 'auth/currentUser',
      offer: 'offers/offer',
    }),
    entityId(){
      return this.$route.params.entity_id;
    },
    offerId(){
      return this.$route.params.offer_id;
    },
    adminOfferPage() {
      return { name: 'AdminOffer', params: { id: this.offerId } }
    }
  },
  methods: {
    ...mapActions({
      initReplacementMotivesAction: 'replacementMotives/initReplacementMotives',
      getCurrentUser: 'auth/getUser',
      setMessage: 'message/enable',
      getOffer: 'offers/getOffer'
    }),
    redirectToListPath(){
      this.$router.push({ name: "Offers", params: { entity_id: this.entityId }});
    },
    canUpdate(offer) {
      return canEditOfferContractFields(offer, this.currentUser, offer.entity.id)
    },
    initForm(offer) {
      this.replacedPerson = offer.replaced_person
      this.replacedPersonSalaryCategory = offer.replaced_person_salary_category
      this.replacementMotiveDetails = offer.replacement_detail_attributes.details
      this.salary = offer.salary
      this.replacementMotive = {
        id: offer.replacement_detail_attributes.replacement_motive_id,
        name: offer.replacement_detail_attributes.replacement_motive_name,
      }
    },
    offerParams(){
      return {
        offer: {
          offer_salary: this.salary,
          offer_replaced_person: this.replacedPerson,
          offer_replaced_person_salary_category: this.replacedPersonSalaryCategory,
          offer_replacement_motive_details: this.replacementMotiveDetails,
          offer_replacement_motive_name: {
            id: this.replacementMotive.id
          }
        }
      }
    },
    onSubmit() {
      this.$dialog.confirm(this.$i18n.t('EditOfferContract.confirm'))
        .then(() => {
          this.loading = true
          updateContractFields(this.offerId, this.offerParams())
            .then(() => {
              this.$router.push(this.adminOfferPage)
              this.setMessage({
                type: 'success',
                content: this.$i18n.t('messages.offers.update_success')
              })
            })
            .catch(error => console.error(error))
            .finally(() => this.loading = false)
        })
        .catch(function () {})
    }
  },
  created: async function(){
    this.initReplacementMotivesAction()
    await this.getCurrentUser()
    await this.getOffer(this.offerId)
      .then((offer) => {
        if(!this.canUpdate(offer)){
          this.redirectToListPath();
          this.setMessage({
            type: 'danger',
            content: this.$i18n.t('messages.offers.cant_edit_published_offer')
          })
        }
        this.initForm(offer)
      })
      .catch(error =>{
        this.redirectToListPath();
        this.setMessage({ type: 'danger', content: error.response.data.error })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offers/EditOfferContract.vue